module.exports = __webpack_public_path__ + "img/台州市.edc811b4.png";